<template>
    <div class="distributor-item">
        <div class="distributor-item__inner">
            <ResponsiveImage v-if="distributorItem.ImageHtml.Src || distributorItem.ImageHtml.HasCrop" :imageModel="distributorItem.ImageHtml" wrapClass="distributor-item__image" />
            <div class="distributor-item__info">
                <div class="distributor-item__row">
                    <p class="distributor-item__headline">{{ distributorItem.Name }}</p>
                </div>
                <div class="distributor-item__row"
                    v-if="distributorItem.PoBox || distributorItem.Phone || distributorItem.Mobile || distributorItem.Website || distributorItem.Territory">
                    <p class="distributor-item__text" v-if="distributorItem.PoBox">{{ distributorItem.PoBox }}</p>
                    <p class="distributor-item__text" v-if="distributorItem.Phone">
                        {{ dictionaries.DistributorPhone }} <a :href="'tel:' + distributorItem.Phone"
                            class="distributor-item__link">{{ distributorItem.Phone }}</a>
                    </p>
                    <p class="distributor-item__text" v-if="distributorItem.Mobile">
                        {{ dictionaries.DistributorMobile }} <a :href="'tel:' + distributorItem.Mobile"
                            class="distributor-item__link">{{ distributorItem.Mobile }}</a>
                    </p>
                    <p class="distributor-item__text" v-if="distributorItem.HasWebsite">
                        {{ dictionaries.DistributorWebsite }} <a :href="distributorItem.WebsiteUrl"
                            class="distributor-item__link"
                            :target="distributorItem.WebsiteTarget">{{ distributorItem.WebsiteName }}</a>
                    </p>
                    <p class="distributor-item__text" v-if="distributorItem.Territory">
                        {{ dictionaries.DistributorTerritory }} {{ distributorItem.Territory }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";

export default {
    name: "distributorItem",
    components: {
        ResponsiveImage
    },
    props: ["distributorItem", "dictionaries"]
};
</script>